import React from 'react';
import { FaChevronUp, FaWhatsapp, FaYoutube, FaFacebookF } from 'react-icons/fa';

// Assets Imports
import waveImg from '../../assets/images/background-white-color-1.png';
import logoImg from '../../assets/images/Logo2.PNG';
import footerBgImg from '../../assets/images/contact-bg.jpg';

const SubPageFooter = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    { 
      id: 1, 
      icon: <FaWhatsapp />, 
      url: "https://wa.me/+918080420434", 
      color: "hover:bg-[#25D366]" 
    },
    { 
      id: 2, 
      icon: <FaYoutube />, 
      url: "https://www.youtube.com/channel/UC-5_Tt6MGrqT962oHQ4X6g", 
      color: "hover:bg-[#FF0000]" 
    },
    { 
      id: 3, 
      icon: <FaFacebookF />, 
      url: "https://m.facebook.com/vinay.satpute.35", 
      color: "hover:bg-[#1877F2]" 
    },
  ];

  return (
    <footer className="relative w-full overflow-hidden" style={{ fontFamily: "'Old Standard TT', serif" }}>
      
      {/* 1. TOP WAVE IMAGE */}
      <div className="absolute top-[-20px] left-0 w-full z-20 select-none pointer-events-none">
        <img 
          src={waveImg} 
          alt="wave-border" 
          className="w-full h-auto object-cover block" 
        />
      </div>
      {/* 2. MAIN FOOTER WITH BACKGROUND IMAGE */}
      <div 
        className="relative py-10 md:py-16 bg-center bg-cover bg-no-repeat text-white"
        style={{ backgroundImage: `url(${footerBgImg})` }}
      >
        {/* Dark Overlay - */}
        <div className="absolute inset-0 bg-black/70 z-0"></div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="flex flex-col  justify-between items-center gap-10">
            
            {/* Left: Logo & Social Links */}
            <div className="flex flex-col items-center">
              <img
                src={logoImg}
                alt="TGSOH Logo"
                className="h-24 w-auto mb-6 object-contain"
              />

              <div className="flex gap-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.id}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 md:w-12 md:h-12 border border-white/50 rounded-full flex items-center justify-center text-white text-xl transition-all duration-300 ${social.color} hover:border-transparent hover:scale-110`}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Middle: Navigation Links */}
            <div className="flex flex-wrap justify-center gap-3 md:gap-8 md:text-base  italic tracking-[2px]">
              <a href="/home" className="text-white transition-colors">Home</a>
              <span className="opacity-40">~</span>
              <a href="/services" className="text-white transition-colors">Our Services</a>
              <span className="opacity-40">~</span>
              <a href="/rates" className="text-white transition-colors">Rates</a>
              <span className="opacity-40">~</span>
              <a href="/blog" className="text-white transition-colors">Read Blog</a>
            </div>

            {/* Right: Copyright */}
            <div className="text-[10px] md:text-[12px] px-4 tracking-[3px] uppercase text-center md:text-right opacity-80 leading-relaxed">
              (C) @Copyright The Global School Of Happiness <br />
              <span className="text-[#54a50f] font-bold">TGSOH TEAM</span>
            </div>
          </div>
        </div>
        
        {/* Scroll Top Button */}
        <button 
          onClick={scrollToTop}
          className="fixed bottom-5 right-5 md:bottom-10 md:right-10 p-3 md:p-4 bg-[#54a50f]  rounded-full shadow-2xl hover:scale-110 transition-transform z-50 group"
        >
          <FaChevronUp className="text-white group-hover:animate-bounce" />
        </button>
      </div>
    </footer>
  );
};

export default SubPageFooter;